import React from 'react';
import { Box, Card, CardContent, Stack } from '@mui/material';
import LocationPanel from './LocationPanel';
import RadarPanel from './RadarPanel';
function RadarChart() {
    return (React.createElement(Card, null,
        React.createElement(CardContent, { sx: { py: '8px !important' } },
            React.createElement(Stack, { direction: "row", gap: 1 },
                React.createElement(Box, { sx: { flex: 2 } },
                    React.createElement(LocationPanel, null)),
                React.createElement(Box, { sx: { flex: 1 } },
                    React.createElement(RadarPanel, null))))));
}
export default React.memo(RadarChart);
